<template>
    <div class="d-flex justify-content-center align-items-center text-center my-5" style="min-height: calc(100vh - 413px);">
        <div class="col-10 col-md-6 col-lg-7">
            <h1 class="mb-4">Page Error</h1>
            <h2 class="h3">It seems the page you are requesting does not exist.</h2>
            <div><img class="img-fluid my-5" src="@/assets/general/404error.png" /></div>
            <router-link class="btn btn-outline-dark rounded-0 py-3 px-4" to="/">Back to home page</router-link>
        </div>
    </div>
</template>